import classNames from 'classnames';
import { RiskOfDeclineChart as theme } from 'legacy/css-modules';

const _getRiskLevel = (value) => {
  if (value <= 10) {
    return 'Very Low';
  } else if (value <= 30) {
    return 'Low';
  } else if (value < 50) {
    return 'Neutral';
  } else if (value < 70) {
    return 'High';
  } else {
    return 'Very High';
  }
};

const COLORS = {
  'Very Low': '#2bdba9',
  Low: '#a7e765',
  Neutral: '#eed43e',
  High: '#fab34e',
  'Very High': '#fd895e'
};

const TICK_WIDTH = 4;

const RiskOfDeclineChart = ({ max, min, value, dataHcName }) => {
  const subjectLeft = value ? ((value - min) / (max - min)) * 100 : 0;
  const riskLevel = _getRiskLevel(value);
  let position = { left: `${subjectLeft}%` };
  let alignment = 'Center';
  // These values were chosen so the subject value label doesn't render off-screen
  if (value < 18) {
    position = { left: `calc(${subjectLeft}% - ${TICK_WIDTH / 2}px)` };
    alignment = 'Left';
  } else if (value > 72) {
    position = { left: `${subjectLeft}%` };
    alignment = 'Right';
  }
  return (
    <div className={theme.RiskOfDeclineChart} data-hc-name={dataHcName}>
      <div className={theme.ChartContent}>
        {value && (
          <div
            className={classNames(theme.Subject, theme[`Subject${alignment}`])}
            style={position}
          >
            <div
              className={theme.ValueLabel}
              data-hc-name={`${dataHcName}-value-label`}
            >
              <div
                className={theme.ValueLabelPercent}
                data-hc-name={`${dataHcName}-value-percent`}
              >{`${value.toFixed(1)}%`}</div>
              <div className={theme.ValueLabelDescription}>
                <div data-hc-name={`${dataHcName}-value-description`}>
                  1 Year Risk
                </div>
                <div
                  className={theme.RiskLevel}
                  data-hc-name={`${dataHcName}-value-risk`}
                  style={{ color: COLORS[riskLevel] }}
                >
                  {riskLevel}
                </div>
              </div>
            </div>
            <div className={theme.ValueTick} />
          </div>
        )}
        <div className={theme.Bar}>
          <div className={classNames(theme.Tick, theme.TickVeryLow)} />
          <div className={classNames(theme.Tick, theme.TickLow)} />
          <div className={classNames(theme.Tick, theme.TickNeutral)} />
          <div className={classNames(theme.Tick, theme.TickHigh)} />
        </div>
        <div className={theme.BarLabelContainer}>
          <div
            className={classNames(
              theme.BarLabel,
              theme.BarLabelExtreme,
              theme.LabelVeryLow
            )}
          >
            very low
          </div>
          <div className={classNames(theme.BarLabel, theme.LabelLow)}>low</div>
          <div className={classNames(theme.BarLabel, theme.LabelNeutral)}>
            neutral
          </div>
          <div className={classNames(theme.BarLabel, theme.LabelHigh)}>
            high
          </div>
          <div
            className={classNames(
              theme.BarLabel,
              theme.BarLabelExtreme,
              theme.LabelVeryHigh
            )}
          >
            very high
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskOfDeclineChart;
